'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../_commonjsHelpers-6ecf82ef.js');
require('../extends-733dd656.js');
require('react');
require('../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../xstyled-styled-components.es-6e2bde7d.js');
require('../extends-5ede7877.js');
require('../unsupportedIterableToArray-f175acfa.js');
require('../breakpoints-ee0a4ae5.js');
require('../utils/env/isTestEnv/isTestEnv.js');
var utils_env_isBrowserEnv_isBrowserEnv = require('../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../utils/env/isProdEnv/isProdEnv.js');
require('../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
var styles_theme = require('../theme-80c5a73f.js');
require('../polished.esm-8ddeb0a5.js');
require('../colorBuilder-8c1a81a8.js');
var utils_isType_isType = require('../utils/isType/isType.js');

var hasColorInNuDS = function hasColorInNuDS(colorName) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    theme: styles_theme.theme
  },
      theme = _ref.theme;

  var currentColor = theme.colors[colorName];
  return Boolean(currentColor);
};
function isColorNameCSSDefinition(colorName) {
  var GLOBAL_COLORS = new Set(['inherit', 'currentColor', 'initial', 'unset', 'transparent']);
  return GLOBAL_COLORS.has(colorName);
}
var NEW_COLOR_REGEX = /^\w+\.\w+$/;
var isLegacyColor = function isLegacyColor(color) {
  return !NEW_COLOR_REGEX.test(color);
};
function nuDSColor(colorName) {
  var colorVariant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var isWarnEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      theme: styles_theme.theme
    };
    var theme = props.theme;
    var themeColor = theme.colors[colorName];
    var hasColor = Boolean(themeColor);

    if (!isLegacyColor(colorName)) {
      return xstyledStyledComponents_es.getColor(colorName);
    }

    if (!hasColor) {
      if (!isColorNameCSSDefinition(colorName) && utils_env_isBrowserEnv_isBrowserEnv.isBrowserEnv && isWarnEnabled) {
        console.warn("Color \"".concat(colorName, "\" doesn't exist in NuDS"));
      }

      return colorName;
    }

    if (utils_isType_isType.isType('string', themeColor)) {
      return themeColor;
    }

    var themeColorVariant = themeColor[colorVariant];
    var hasColorVariant = Boolean(themeColorVariant);

    if (!hasColorVariant) {
      throw new Error("Variant \"".concat(colorVariant, "\" doesn't exist in ").concat(colorName, " on NuDS"));
    }

    return themeColorVariant;
  };
}
var spacing = styles_theme.spacing.bind(null, styles_theme.theme);

exports.hasColorInNuDS = hasColorInNuDS;
exports.isColorNameCSSDefinition = isColorNameCSSDefinition;
exports.isLegacyColor = isLegacyColor;
exports.nuDSColor = nuDSColor;
exports.spacing = spacing;
//# sourceMappingURL=themeUtils.js.map
